import tns from '@/lib/tiny-slider/tiny-slider.js';

(function () {
    // Initialize gl-gallery sliders using tiny-slider (vanilla JS)
    function initGlGallery() {

        var galleries = document.querySelectorAll('.gl-gallery');
        galleries.forEach(function (gallery) {
            var container = gallery.querySelector('.carousel-slider');
            if (!container) return;

            var slider = tns({
                container: container,
                items: 1,
                slideBy: 1,
                autoplay: false,
                controls: false, // we'll wire up custom controls if present
                nav: false,
                autoplayButton: false,
                swipeAngle: false,
                speed: 300
            });

            var prev = gallery.querySelector('.slick-prev, .left-arrow, .prev');
            var next = gallery.querySelector('.slick-next, .right-arrow, .next');

            if (prev) {
                prev.addEventListener('click', function (e) {
                    if (e && e.preventDefault) e.preventDefault();
                    slider.goTo('prev');
                });
            }
            if (next) {
                next.addEventListener('click', function (e) {
                    if (e && e.preventDefault) e.preventDefault();
                    slider.goTo('next');
                });
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initGlGallery);
    } else {
        initGlGallery();
    }
})();


